import type { ReactNode } from 'react'
import { cn } from '@core/lib/utils'

interface AuthLayoutProps {
  children: ReactNode
  className?: string
}

const AuthLayout = ({ children, className }: AuthLayoutProps) => {
  return (
    <div className="min-h-screen w-full lg:grid lg:grid-cols-2">
      {/* Left side - Image section */}
      <div className="relative hidden lg:block">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${import.meta.env.VITE_BACKGROUND_URL ?? "https://images.unsplash.com/photo-1590069261209-f8e9b8642343?ixlib=rb-4.0.3&auto=format&fit=crop&w=1376&q=80"})`, // TODO: When we will have png per-client we can substitute here
          }}
        />
        <div className="absolute inset-0 bg-zinc-900/60" />
      </div>

      {/* Right side - Form section */}
      <div
        className={cn(
          'relative flex min-h-screen flex-col items-center justify-center p-4 sm:p-8 lg:p-12',
          'bg-background',
          'lg:border-l lg:border-border',
          'lg:shadow-2xl lg:shadow-black/10',
          className
        )}
      >

        <div className="w-full max-w-md space-y-6">
          {children}
        </div>
      </div>
    </div>
  )
}

export default AuthLayout